import type { FandomCmp } from "common-types";

export type ConsentChecks = {
  ignoreOptOut?: boolean;
  ignoreAllowedAds?: boolean;
  ignoreCoppa?: boolean;
};
const defaultChecks: ConsentChecks = {
  ignoreOptOut: false,
  ignoreAllowedAds: false,
  ignoreCoppa: false,
};

/**
 * Checks if consent is granted based on the provided FandomCmp object and optional checks.
 * By default, it checks that {@link FandomCmp} has the following configuration of its properties:
 * `optOut = false`, `coppa = false`, `allowed.ads = true`, and `ready = true`.
 *
 * You can override the default checks by passing an object with {@link ConsentChecks} properties.
 * For now, the only available properties are `ignoreAllowedAds` and `ignoreCoppa`.
 *
 * @param {FandomCmp} fandomCmp
 * @param {ConsentChecks} customChecks
 */
export const isConsentGranted = (
  fandomCmp?: FandomCmp,
  customChecks: ConsentChecks = {},
): boolean => {
  const { ignoreAllowedAds, ignoreCoppa, ignoreOptOut } = {
    ...defaultChecks,
    ...customChecks,
  };
  const check = (flag: boolean, ignore?: boolean): boolean =>
    ignore ? true : !flag;

  return Boolean(
    fandomCmp &&
      fandomCmp.ready &&
      check(fandomCmp.optOut, ignoreOptOut) &&
      check(!fandomCmp.allowed?.ads, ignoreAllowedAds) &&
      check(fandomCmp.coppa, ignoreCoppa),
  );
};
